import * as yup from "yup"

import { I18N_NAMESPACE } from "../../constants/i18n"

export const validationSchema = (t) => yup.object().shape({
    file: yup.mixed(),
    filename: yup.string().when("file", {
        is: (file) => !!file,
        then: yup.string()
            .required(t(I18N_NAMESPACE, "forms.documentAddForm.fileName.required"))
            .test(
                "not-extension-only",
                t(I18N_NAMESPACE, "forms.documentAddForm.fileName.required"),
                (value) => {
                    if (!value) {
                        return false
                    }
                    return !/^\.\w+$/.test(value.trim())
                },
            ),
        otherwise: yup.string().notRequired(),
    }),
    document_type: yup.string(),
    date: yup.date(),
    tags: yup.array(yup.string()),
})